////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationDefinition = {
	resetDataCreationCustomer: () => ({
		type: ActionsTypes.RESET_DATA_CREATION_DEFINITION_CUSTOMER,
	}),
	getAvailableListsCustomer: () => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS,
	}),
	getAvailableListsCustomerSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_SUCCESS,
		payload: {
			data,
		},
	}),
	getAvailableListsCustomerFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_AVAILABLE_LISTS_FAILURE,
		payload: {
			error,
		},
	}),
	resetDataCreationBusiness: () => ({
		type: ActionsTypes.RESET_DATA_CREATION_DEFINITION_BUSINESS,
	}),
	getAvailableListsBusiness: () => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS,
	}),
	getAvailableListsBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_SUCCESS,
		payload: {
			data,
		},
	}),
	getAvailableListsBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_AVAILABLE_LISTS_FAILURE,
		payload: {
			error,
		},
	}),
	getProfilesByKioskCustomer: (idKioskModel) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK,
		payload: {
			idKioskModel,
		},
	}),
	getProfilesByKioskCustomerSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_SUCCESS,
		payload: {
			data,
		},
	}),
	getProfilesByKioskCustomerFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_BYKIOSK_FAILURE,
		payload: {
			error,
		},
	}),
	getProfileConfigCustomer: (idProfile) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE,
		payload: {
			idProfile,
		},
	}),
	getProfileConfigCustomerSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_SUCCESS,
		payload: {
			data,
		},
	}),
	getProfileConfigCustomerFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_PROFILE_FAILURE,
		payload: {
			error,
		},
	}),
	saveDefinitionCustomer: (data) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER,
		payload: {
			data,
		},
	}),
	saveDefinitionCustomerSuccess: (data) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	saveDefinitionCustomerFailure: (error) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	createDefinitionCustomer: (data) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER,
		payload: {
			data,
		},
	}),
	createDefinitionCustomerSuccess: (data) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	createDefinitionCustomerFailure: (error) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	getDefinitionCustomer: (id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER,
		payload: {
			id,
		},
	}),
	getDefinitionCustomerSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_SUCCESS,
		payload: {
			data,
		},
	}),
	getDefinitionCustomerFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_CUSTOMER_FAILURE,
		payload: {
			error,
		},
	}),
	getProfilesConfigBusiness: (idProfile) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES,
		payload: {
			idProfile,
		},
	}),
	getProfilesConfigBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_SUCCESS,
		payload: {
			data,
		},
	}),
	getProfilesConfigBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILES_FAILURE,
		payload: {
			error,
		},
	}),
	saveDefinitionBusiness: (data) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS,
		payload: {
			data,
		},
	}),
	saveDefinitionBusinessSuccess: (data) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	saveDefinitionBusinessFailure: (error) => ({
		type: ActionsTypes.SAVE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	createDefinitionBusiness: (data) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS,
		payload: {
			data,
		},
	}),
	createDefinitionBusinessSuccess: (data) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	createDefinitionBusinessFailure: (error) => ({
		type: ActionsTypes.CREATE_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	getDefinitionBusiness: (id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS,
		payload: {
			id,
		},
	}),
	getDefinitionBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	getDefinitionBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
	getProfilesByKioskBusiness: (idKioskModel) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK,
		payload: {
			idKioskModel,
		},
	}),
	getProfilesByKioskBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_SUCCESS,
		payload: {
			data,
		},
	}),
	getProfilesByKioskBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_BYKIOSK_FAILURE,
		payload: {
			error,
		},
	}),
	getProfileConfigBusiness: (idProfile) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE,
		payload: {
			idProfile,
		},
	}),
	getProfileConfigBusinessSuccess: (data) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_SUCCESS,
		payload: {
			data,
		},
	}),
	getProfileConfigBusinessFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_DEFINITION_BUSINESS_PROFILE_FAILURE,
		payload: {
			error,
		},
	}),
	refreshDefinitionBusiness: (id) => ({
		type: ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS,
		payload: {
			id,
		},
	}),
	refreshDefinitionBusinessSuccess: (data) => ({
		type: ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_SUCCESS,
		payload: {
			data,
		},
	}),
	refreshDefinitionBusinessFailure: (error) => ({
		type: ActionsTypes.REFRESH_KIOSK_CREATION_DEFINITION_BUSINESS_FAILURE,
		payload: {
			error,
		},
	}),
}

export default initKioskCreationDefinition
